module.exports = __webpack_public_path__ + "img/logo.0bd01807.png";